import { Ability } from '@casl/ability'
import { initialAbility } from './config'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
let userData = null
let existingAbility = null

try {
  const userDataString = localStorage.getItem('userData')
  if (userDataString && userDataString !== 'undefined') {
    userData = JSON.parse(userDataString)
    existingAbility = userData ? userData.ability : null
  }
} catch (error) {
  console.error('Error parsing userData from localStorage:', error)
}

export default new Ability(existingAbility || initialAbility)
